<template>
  <b-card>
    <usuario-interno-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
      filtrar-por-ativo
    >
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.field === 'departamentosNome'">
          <div
            v-for="(dep, $index) in props.row.departamentosNome"
            :key="$index"
            class="d-inline-flex"
          >
            <span
              class="badge badge-secondary departamento-badge"
            >{{ dep }}</span>
          </div>
        </span>
      </template>

      <template
        slot="corpo-info-adicional"
        slot-scope="{props}"
      >
        <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        <b-row class="mb-1">
          <b-col
            cols="12"
            style="text-align:center"
          >
            <span>Empresas Vinculadas</span>
          </b-col>
        </b-row>
        <div
          v-for="(empresaVinculada, i) in props.row.empresas"
          :key="i"
        >
          <b-row>
            <b-col cols="12">
              <span
                class="empresa-vinculada"
                @click="acessaEmpresa(empresaVinculada.id)"
              >{{ `${empresaVinculada.razaoSocial} - ${empresaVinculada.cadastroFederal}` }}</span>
            </b-col>
          </b-row>
        </div>
      </template>
    </usuario-interno-list>
  </b-card>
</template>

<style lang="scss">
.departamento-badge{
  margin-right:0.3rem;
  background-color:transparent;
  border: 1px solid #82868b !important;
  color: #82868b;
  height: 1.5rem;
  font-size: 12px;
  font-weight: 700;
}

.empresa-vinculada:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>

<script>
import api from '@/app-modulo/comuns/usuario-interno/shared/services/api'

export default {
  name: 'UsuarioInternoVisualizacao',
  components: {
    UsuarioInternoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nomeCompleto', type: 'personalizada', showActive: true, editable: true,
        },
        { label: 'CPF', field: 'cpf', width: '150px' },
        { label: 'Função', field: 'funcaoNome' },
        { label: 'Departamentos', field: 'departamentosNome', type: 'personalizada' },
      ],
      filtros: [{ colunas: ['NomeCompleto', 'CPF', 'DepartamentosNome', 'FuncaoNome', 'Login'], valor: null }],
      info: [
        { label: 'Último acesso: ', campo: 'dataUltimoAcesso' },
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getUsuariosInternos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-usuario-interno' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-usuario-interno', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise(resolve => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteUsuarioInterno(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              throw err
            })
        }
      })
    },
    acessaEmpresa(id) {
      this.$router.push(`/empresas/editar/${id}`)
    },
  },
}
</script>
